<script>
  import BrandLayout from '../components/Layout'
  import ArticleContent from '@components/Article/ArticleContent'
  import ArticleFooter from '@components/Article/ArticleFooter'
  import ArticleSide from '@components/Article/ArticleSide'
  import ArticleKeyWord from '@components/Article/ArticleKeyWord'
  import ArticleRative from '@components/Article/ArticleRative'
  import ArticleSticky from '@components/Article/ArticleSticky'
  import ListProduct from "@components/List/Product";
  import pageGAMixin from "../mixins/pageGA";

  export default {
    page() {
      return {
        title: `${this.defaultValue.title} | 最新消息`,
      }
    }, 
    components: {
      BrandLayout,
      ArticleContent,
      ArticleFooter,
      ArticleSide,
      ArticleKeyWord,
      ArticleSticky,
      ListProduct
    },
    mixins: [pageGAMixin],
    props: {
      defaultValue: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        type: 'news',
        // articleTypeChinese: '促銷訊息',

      }
    },
    computed: {
      brandLink() {
        const { brands } = this.defaultValue
        return [
          {
            alias: brands[0].alias,
            logo_image: brands[0].logo_image,
            contact: brands[0].contact,
            title: brands[0].title,
          }
        ]
      },
      productList() {
        return this.defaultValue.products.map((item) => ({
          title: item.title,
          alias: item.alias,
          categoryTitle: item.product_category.title,
          brands: item.brands,
          to: {
            name: 'brand-product-item',
            params: {
              productAlias: item.alias,
              brandAlias: item.brands[0].alias
            }
          },
        }))
      },
    },
    methods: {
      backTo(to) {
        const name = () => {
          switch(to) {
            case 'news-item':
              return 'news-category';
            case 'brand-news-item':
              return 'brand-news-category'
          }
        };
        const params = () => {
          switch(to) {
            case 'news-item':
              return {
                categoryAlias: this.$route.params.categoryAlias,
              };
            case 'brand-news-item':
              return {
                brandAlias: this.$route.params.brandAlias,
                categoryTitle: this.$route.params.categoryAlias
              }
          }
        };
        return {
          name: name(),
          params: params()
        }
      },
    }
  }
</script>
<template>
  <BrandLayout :page-type="type">
    <BaseBanner
      :title="defaultValue.title"
      type="article"
      :image="defaultValue.image ? defaultValue.image : ''"
      :sub-title="defaultValue.extrafields.subtitle.value ? defaultValue.extrafields.subtitle.value : ''"
    >
      <div v-if="defaultValue.publish_up" class="d-md-none color-white mt-4 text-2sm">
        <i class="icomoon icon-time"></i>
        {{defaultValue.publish_up}}
      </div>
    </BaseBanner>
    <div :class="$style.sectionNewsItem">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 order-lg-first order-last">
            <ArticleContent
              :time="defaultValue.publish_up"
              :article-text="defaultValue.description"
            />
            <ArticleKeyWord
              v-if="defaultValue.tags.length"
              :list="defaultValue.tags"
              class="mt-4 d-lg-none d-block"
            />
            <ArticleFooter
              :data="{
              ...defaultValue,
              to: backTo($route.name),
            }"
              :text="$route.params.categoryAlias === 'bulletin'
                ? '品牌新訊'
                : '促銷訊息'"
              :content-type="type"
            />
          </div>
          <div class="col-lg-5">
            <BaseSticky
              :offset="-190"
              :banner-height="415"
              :menu-height="113"
              :space-top="123"
              :space-bottom="40"
            >
              <ArticleSide
                :type="type"
                :info="defaultValue"
                :brand-link="brandLink"
              />
              <ArticleKeyWord
                v-if="defaultValue.tags.length"
                :list="defaultValue.tags"
                class="mt-4 d-lg-block d-none"
              />
            </BaseSticky>
            <!--<ArticleSticky>
              <ArticleSide :type="type" :info="defaultValue" :brand-link="brandLink"/>
              <ArticleKeyWord v-if="defaultValue.tags.length" :list="defaultValue.tags"/>
            </ArticleSticky>-->
          </div>
        </div>
      </div>
      <!--<ArticleRative :list="productList" :type="type" link-type="list" />-->
      <section
        v-if="defaultValue.products.length"
        class="section"
        :class="$style.sectionRelated"
      >
        <div class="container">
          <BaseSectionTitle
            title="相關產品"
            class="text-center mb-md-5 mb-2 mt-md-0 mt-3"
          />
          <ListProduct
            type="carousel"
            link-type="list"
            :list="productList"
            class="pt-3"
          />
        </div>
      </section>
    </div>
  </BrandLayout>
</template>

<style lang="scss" module>
  .sectionNewsItem {
    .sectionRelated {
      background: rgb(244, 246, 250);

      :global {
        .sectionRelated {
          :global {

          }
        }
      }
    }
  }

</style>
